// extracted by mini-css-extract-plugin
export default {"title":"xMWLCLOmv-28IX7xU2oKNw==","DE":"_1TeIzSceVA8yV-KzhG4y8w=="};